import { Button, DatePicker, Input, Select } from "antd";
import styled from "styled-components";
const { RangePicker } = DatePicker

export const InputBox = styled(Input)`
    input{
        font-size:14px;
    }
`;
export const XButton = styled(Button)`
    font-size:14px;
    border-radius:7px !important;
`;